import { render } from "./WorkItems.vue?vue&type=template&id=61d89f2e&scoped=true&ts=true"
import script from "./WorkItems.vue?vue&type=script&lang=ts"
export * from "./WorkItems.vue?vue&type=script&lang=ts"

import "@/components/SelectedWork/WorkItem/style.scss?vue&type=style&index=0&id=61d89f2e&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d89f2e"]])

export default __exports__